import { useEffect, useState } from "react";
import {
  Banknote, Receipt, AlertTriangle, Package, Users, Truck,
} from "lucide-react";
import api from "@/lib/api";
import { PageHeader } from "@/components/Common";

function KpiCard({ label, value, icon: Icon, accent = "#84978F", testid }) {
  return (
    <div data-testid={testid} className="card-soft p-6">
      <div className="flex items-start justify-between">
        <p className="text-xs uppercase tracking-[0.2em] text-[#8A9A92]">{label}</p>
        <div className="w-9 h-9 rounded-lg grid place-items-center" style={{ background: `${accent}22` }}>
          <Icon className="w-[18px] h-[18px]" strokeWidth={1.7} style={{ color: accent }} />
        </div>
      </div>
      <p className="font-heading text-3xl font-black mt-4 text-[#2A3F35]">{value}</p>
    </div>
  );
}

export default function Dashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/dashboard/stats").then((r) => setStats(r.data));
  }, []);

  const fmtMoney = (v) => `$ ${Number(v || 0).toFixed(2)}`;

  return (
    <div data-testid="dashboard-page">
      <PageHeader
        title="Panel de control"
        subtitle="Resumen del estado de tu floristería en tiempo real."
        testid="dashboard-header"
      />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
        <KpiCard testid="kpi-sales-today" label="Ventas hoy" value={fmtMoney(stats?.sales_today)} icon={Banknote} accent="#507A59" />
        <KpiCard testid="kpi-sales-total" label="Ventas totales" value={fmtMoney(stats?.sales_total)} icon={Banknote} accent="#2A3F35" />
        <KpiCard testid="kpi-invoices-total" label="Facturas" value={stats?.invoices_total ?? 0} icon={Receipt} accent="#608090" />
        <KpiCard testid="kpi-invoices-pending" label="Pendientes SRI" value={stats?.invoices_pending_sri ?? 0} icon={AlertTriangle} accent="#C27A62" />
        <KpiCard testid="kpi-products" label="Productos activos" value={stats?.products_count ?? 0} icon={Package} accent="#84978F" />
        <KpiCard testid="kpi-low-stock" label="Stock bajo" value={stats?.low_stock_count ?? 0} icon={AlertTriangle} accent="#A44A4A" />
        <KpiCard testid="kpi-customers" label="Clientes" value={stats?.customers_count ?? 0} icon={Users} accent="#608090" />
        <KpiCard testid="kpi-suppliers" label="Proveedores" value={stats?.suppliers_count ?? 0} icon={Truck} accent="#84978F" />
      </div>

      <div className="card-soft mt-8 p-6">
        <p className="text-xs uppercase tracking-[0.22em] text-[#8A9A92] mb-2">Próximos pasos</p>
        <h3 className="font-heading text-xl font-bold mb-3">Configura tu floristería</h3>
        <ol className="list-decimal pl-5 text-sm text-[#5C6B64] space-y-1">
          <li>Configura el RUC, razón social y certificado .p12 en <strong>Ajustes</strong>.</li>
          <li>Registra <strong>Proveedores</strong>, <strong>Tipos de flores</strong> y <strong>Productos</strong>.</li>
          <li>Carga entradas de inventario en el <strong>Kardex</strong>.</li>
          <li>Crea facturas y fírmalas/envíalas al SRI desde la sección <strong>Facturas SRI</strong>.</li>
        </ol>
      </div>
    </div>
  );
}
